import { render, staticRenderFns } from "./bindtel.vue?vue&type=template&id=f86baa04&scoped=true"
import script from "./bindtel.vue?vue&type=script&lang=js"
export * from "./bindtel.vue?vue&type=script&lang=js"
import style0 from "./bindtel.vue?vue&type=style&index=0&id=f86baa04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86baa04",
  null
  
)

export default component.exports